export default __webpack_public_path__ + "static/media/lottery_pc@2x.0ee111d0.jpg";